"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _server = _interopRequireDefault(require("react-dom/server"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _columnTypes = _interopRequireDefault(require("./columnTypes"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _max2 = _interopRequireDefault(require("lodash/max"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _UserRow = _interopRequireDefault(require("./UserRow.js"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _classnames2 = _interopRequireDefault(require("classnames"));
var _settings = require("./settings.js");
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _defaultTemplate = _interopRequireDefault(require("./defaultTemplate.js"));
var _style = _interopRequireDefault(require("./style.css"));
var _isInt = _interopRequireDefault(require("validator/lib/isInt"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Player = /*#__PURE__*/function (_React$Component) {
  _inherits(Player, _React$Component);
  function Player() {
    var _this;
    _classCallCheck(this, Player);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Player, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._setUserLists();
      _this._setUserRows();
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      _this._setUserLists();
      _this._setUserRows();
    });
    _defineProperty(_assertThisInitialized(_this), "_setUserLists", function () {
      var _this$props = _this.props,
        settings = _this$props.settings,
        dynamicUserListsValues = _this$props.dynamicUserListsValues;
      settings.rows.filter(function (item) {
        return item.type === 'userList';
      }).forEach(function (row) {
        var rowType = settings.rowTypes.userList.find(function (item) {
          return item.id === row.id;
        });
        var users = dynamicUserListsValues[rowType.handle];
        if (!users) {
          return;
        }
        var existingPawnIds = _this.props.field["cell_".concat(row.id)].map(function (item) {
          return item.pawnId.value;
        });
        users.filter(function (item) {
          return !existingPawnIds.includes(item.pawnId);
        }).forEach(function (user) {
          _this.props.field["cell_".concat(row.id)].addField(_objectSpread({
            id: user.pawnId
          }, user));
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_setUserRows", function () {
      var _this$props2 = _this.props,
        settings = _this$props2.settings,
        field = _this$props2.field,
        isPreview = _this$props2.isPreview;
      if (isPreview || !settings.allowUserRows) {
        return;
      }
      var neededUserRowsCount = settings.minUserRows * 1 - field.userRows.length;
      if (neededUserRowsCount <= 0) {
        return;
      }
      var newUserRowId = _this._getNewUserRowId();
      for (var i = 0; i < neededUserRowsCount; i++) {
        var id = newUserRowId + i;
        _this.props.field.userRows.addField({
          id: id,
          label: ''
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_getRegisterAction", function (positionInMatrix) {
      return function (position, action) {
        _this.props.registerAction(positionInMatrix * 1000 + position, action);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "_renderColumn", function (column, field, position) {
      var id = column.id,
        type = column.type;
      if (!_columnTypes["default"][type]) {
        console.error("\"".concat(type, "\" column type is undefined"));
        return null;
      }
      var Component = _columnTypes["default"][type].component;
      var settings = (0, _find2["default"])(_this.props.settings.columnTypes[type], function (item) {
        return item.id === id;
      });
      var template;
      var templateExtraProps;
      var customTemplate = (0, _find2["default"])(_this.props.availableComponentTemplates[column.type], {
        name: column.template
      });
      if (customTemplate) {
        template = customTemplate.component;
        templateExtraProps = {
          templateSettings: column.templateSettings,
          storage: _this.props.storage,
          setToStorage: _this.props.setToStorage,
          pubSub: _this.props.pubSub,
          pawnId: _this.props.pawnId
        };
      }
      return /*#__PURE__*/_react["default"].createElement(Component, {
        settings: settings,
        field: field,
        accommodations: _this.props.accommodations,
        setParameters: _this.props.setParameters,
        isPrintMode: _this.props.isPrintMode,
        registerAction: _this._getRegisterAction(position),
        template: template,
        templateExtraProps: templateExtraProps,
        playerTemplateProps: _this.props.playerTemplateProps
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_getNewUserRowId", function () {
      return ((0, _max2["default"])(_this.props.field.userRows.map(function (row) {
        return row.id.value;
      })) || 0) + 1;
    });
    _defineProperty(_assertThisInitialized(_this), "_addUserRow", function (event) {
      if (event) {
        event.preventDefault();
      }
      var id = _this._getNewUserRowId();
      _this.props.field.userRows.addField({
        id: id,
        label: ''
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_deleteUserRow", function (index) {
      _this.props.field.userRows.removeField(index);
    });
    _defineProperty(_assertThisInitialized(_this), "_canAddNewRow", function () {
      return _this.props.field.userRows && _this.props.field.userRows.length < _this.props.settings.maxUserRows;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderAddRowButton", function () {
      var settings = _this.props.settings;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].addRowWrapper
      }, _this._canAddNewRow() ? /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-default btn-sm",
        onClick: _this._addUserRow
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-plus"
      }), " ", settings.addUserRowText || 'Add new row') : /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-default btn-sm",
        disabled: true
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-plus"
      }), " ", settings.addUserRowText || 'Add new row'), /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-info",
        style: {
          marginLeft: '.5em'
        }
      }, "You cannot add more than ".concat(settings.maxUserRows, " rows"))));
    });
    return _this;
  }
  _createClass(Player, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        field = _this$props3.field,
        settings = _this$props3.settings,
        setParameters = _this$props3.setParameters,
        registerAction = _this$props3.registerAction,
        showQuestionNumbers = _this$props3.showQuestionNumbers,
        startQuestionNumber = _this$props3.startQuestionNumber,
        dynamicUserListsValues = _this$props3.dynamicUserListsValues;
      var headers = [];
      var rows = [];
      var position = 2;
      var questionNumber = startQuestionNumber;
      var elementStyle = (0, _get2["default"])(this.props, 'playerTemplateProps.playerTemplateSettings.elementStyle');
      var choiceAccommodations = _objectSpread(_objectSpread({}, this.props.accommodations), {}, {
        autoplayQuestions: false
      });
      var question = settings.question && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: settings.question,
        registerAction: registerAction.bind(null, 1),
        setParameters: setParameters,
        accommodations: this.props.accommodations,
        prependWith: showQuestionNumbers && settings.questionNumbersForMainQuestion && "".concat(questionNumber++, ". ")
      }), settings.description && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].description
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: settings.description
      })));
      if (settings.rows) {
        headers.push({
          key: 0,
          content: /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            content: settings.cornerHeader,
            registerAction: registerAction.bind(null, position++),
            setParameters: setParameters,
            accommodations: choiceAccommodations
          })
        });
        settings.columns.forEach(function (column) {
          var columnType = _columnTypes["default"][column.type];
          var columnHeader;
          if (columnType.renderHeader) {
            var columnTypeSettings = (0, _find2["default"])(settings.columnTypes[column.type], {
              id: column.id
            });
            columnHeader = columnType.renderHeader({
              settings: columnTypeSettings,
              column: column,
              accommodations: choiceAccommodations,
              setParameters: setParameters
            });
          }
          headers.push({
            key: column.id,
            className: _style["default"][column.headerPosition],
            content: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
              content: column.label,
              registerAction: registerAction.bind(null, position++),
              setParameters: setParameters,
              accommodations: choiceAccommodations
            }), columnHeader)
          });
        });

        // Rows from settings
        settings.rows.forEach(function (row) {
          if (row.type === 'static') {
            var columns = settings.columns.map(function (column) {
              var columnField = field["cell_".concat(row.id, "_").concat(column.id)] || {};
              return {
                key: column.id,
                className: _style["default"][column.type] + ' ' + _style["default"][column.position],
                style: {
                  width: column.width
                },
                content: _this2._renderColumn(column, columnField, position++)
              };
            });
            rows.push({
              key: row.id,
              columns: [{
                key: 0,
                className: _style["default"][row.position],
                style: {
                  width: (0, _isInt["default"])(settings.rowHeaderWidth) ? "".concat(settings.rowHeaderWidth, "px") : settings.rowHeaderWidth
                },
                content: /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
                  content: row.label,
                  registerAction: registerAction.bind(null, position++),
                  setParameters: setParameters,
                  accommodations: choiceAccommodations,
                  prependWith: showQuestionNumbers && settings.questionNumbersForRows && "".concat(questionNumber++, ". ")
                })
              }].concat(_toConsumableArray(columns))
            });
          } else if (row.type === 'userList') {
            var rowType = settings.rowTypes.userList.find(function (item) {
              return item.id === row.id;
            });
            var users = dynamicUserListsValues[rowType.handle] || [];
            field["cell_".concat(row.id)].forEach(function (userRow, index) {
              var columns = settings.columns.map(function (column) {
                var columnField = userRow["column_".concat(column.id)];
                return {
                  key: column.id,
                  className: _style["default"][column.type] + ' ' + _style["default"][column.position],
                  style: {
                    width: column.width
                  },
                  content: _this2._renderColumn(column, columnField, position++)
                };
              });
              var userInfo = users.find(function (item) {
                return item.pawnId === userRow.pawnId.value;
              });

              // Don't show user row if the user is not in the recent list
              if (userInfo) {
                rows.push({
                  key: "".concat(row.id, "_").concat(userRow.pawnId.value),
                  columns: [{
                    key: 0,
                    className: _style["default"][row.position],
                    style: {
                      width: (0, _isInt["default"])(settings.rowHeaderWidth) ? "".concat(settings.rowHeaderWidth, "px") : settings.rowHeaderWidth
                    },
                    content: /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
                      content: userInfo.name,
                      prependWith: showQuestionNumbers && settings.questionNumbersForRows && "".concat(questionNumber++, ". ")
                    })
                  }].concat(_toConsumableArray(columns))
                });
              }
            });
          }
        });

        // Rows from user
        (field.userRows || []).forEach(function (row, index) {
          var columns = settings.columns.map(function (column) {
            var columnField = row["column_".concat(column.id)];
            return {
              key: column.id,
              className: _style["default"][column.type] + ' ' + _style["default"][column.position],
              style: {
                width: column.width
              },
              content: _this2._renderColumn(column, columnField)
            };
          });
          var allowDelete = index >= (settings.minUserRows || 0) * 1;
          rows.push({
            key: 'user_' + row.id.value,
            columns: [{
              key: 0,
              className: 'text-nowrap',
              content: /*#__PURE__*/_react["default"].createElement(_UserRow["default"], {
                field: row.label,
                autoFocus: !_this2.props.isPreview,
                index: index,
                allowDelete: allowDelete,
                deleteUserRow: _this2._deleteUserRow,
                placeholder: settings.userRowPlaceholder
              })
            }].concat(_toConsumableArray(columns)),
            allowDelete: allowDelete,
            deleteUserRow: allowDelete && _this2._deleteUserRow.bind(_this2, index)
          });
        });
      }
      var showHeader = headers.some(function (item) {
        return (0, _cccisdSurveyCommon.stripTags)(_server["default"].renderToStaticMarkup(item.content));
      });
      var templateProps = _objectSpread({
        question: question,
        thead: showHeader ? /*#__PURE__*/_react["default"].createElement("tr", null, headers.map(function (column) {
          return /*#__PURE__*/_react["default"].createElement("th", {
            key: column.key,
            className: column.className,
            style: column.style
          }, column.content);
        })) : null,
        tbody: rows.map(function (row) {
          return /*#__PURE__*/_react["default"].createElement("tr", {
            key: row.key
          }, row.columns.map(function (column) {
            return /*#__PURE__*/_react["default"].createElement("td", {
              key: column.key,
              className: column.className,
              style: column.style
            }, column.content);
          }));
        }),
        addRowButton: this._renderAddRowButton(),
        tableClassName: (0, _classnames2["default"])('table', {
          'table-bordered': settings.isBorderedStyle
        }, {
          'table-striped': settings.isStripedRowsStyle
        }, _defineProperty({}, _style["default"].stripedColumns, settings.isStripedColumnsStyle), _style["default"].table),
        // Advanced props
        settings: settings,
        field: field,
        headers: headers,
        rows: rows,
        columns: settings.columns.map(function (column) {
          return _objectSpread(_objectSpread({}, column), {}, {
            settings: _objectSpread({}, (0, _find2["default"])(settings.columnTypes[column.type], {
              id: column.id
            }))
          });
        }),
        playerTemplateProps: this.props.playerTemplateProps,
        accommodations: this.props.accommodations,
        elementStyle: elementStyle,
        canAddNewRow: this._canAddNewRow(),
        addUserRow: this._addUserRow
      }, this.props.templateExtraProps);
      var Template = this.props.template || _defaultTemplate["default"];
      return /*#__PURE__*/_react["default"].createElement(Template, templateProps);
    }
  }]);
  return Player;
}(_react["default"].Component);
_defineProperty(Player, "propTypes", {
  settings: _propTypes["default"].object,
  field: _propTypes["default"].object,
  registerAction: _propTypes["default"].func,
  setParameters: _propTypes["default"].func,
  accommodations: _propTypes["default"].object,
  template: _propTypes["default"].func,
  templateExtraProps: _propTypes["default"].object,
  playerTemplateProps: _propTypes["default"].object,
  isPreview: _propTypes["default"].bool,
  storage: _propTypes["default"].object,
  setToStorage: _propTypes["default"].func,
  pubSub: _propTypes["default"].object,
  pawnId: _propTypes["default"].number,
  availableComponentTemplates: _propTypes["default"].object,
  showQuestionNumbers: _propTypes["default"].bool,
  startQuestionNumber: _propTypes["default"].number,
  dynamicUserLists: _propTypes["default"].array,
  dynamicUserListsValues: _propTypes["default"].object
});
_defineProperty(Player, "defaultProps", {
  registerAction: function registerAction() {},
  setParameters: function setParameters() {},
  availableComponentTemplates: {},
  dynamicUserListsValues: {}
});
var _default = exports["default"] = (0, _cccisdSurveyCommon.playerWrapper)({
  validate: _settings.validate,
  fields: _settings.fields
})(Player);